<template>
  <template v-if="question?.status !== 'READ_ONLY'">
    <div class="d-flex flex-column inputContainer">
      <label
          class="text-control mb-2 d-flex"
          v-for="(option, index) in question.options"
          :key="index"
          :class="{error: error && hasBeenInteractedWith, 'no-value-checked':!value.length, disclaimer: question.type === 'disclaimer-checkbox',checked:value.indexOf(option.value) > -1, 'justify-content-between align-items-center': shouldPlaceholderWrap }"
      >
        <div v-if="shouldPlaceholderWrap">
          <span class="ms-2 d-block checkbox-title fs-16"  style="align-self: end">
          {{ option.text }}
          </span>
          <span class="ms-2 d-block checkbox-description" style="align-self: end">{{option?.details?.description}}</span>
        </div>
        <input
            v-bind="$attrs"
            type="checkbox"
            :name="question.name"
            :id="`${question.name}-checkbox-${index}`"
            :disabled="disabled"
            style="min-width: 20px;"
            :value="option.value"
            @click.stop="$emit('user-interaction'); setCheckBoxValue(option.value);"
            :checked="value.indexOf(option.value) > -1"
            class="form-check-input mr-3"
        />
        <div v-if="!shouldPlaceholderWrap">
          <span class="ps-3 d-block checkbox-title fs-12"  style="align-self: end">
          {{ option.text }}
          </span>
          <span class="ms-2 d-block checkbox-description" style="align-self: end">{{option?.details?.description}}</span>
        </div>
      </label>
    </div>
    <slot name="helptext" :isConfirm="!disableConfirm && (question.value && question?.prefilled) && !error" :isError="error"
          :confirmCb="() => {$emit('user-interaction'); $emit('confirm');}"></slot>
  </template>

  <ReadOnly
      v-else
      :question="question"
      :value="displayReadOnly"
      :forcePromptPlaceholder="forcePromptPlaceholder"
  />
</template>
<script>
import ReadOnly from "@/components/waffle/components/form-components/ReadOnly.vue";

export default {
  name: "CheckBox",
  components: {ReadOnly},
  emits: ["update:modelValue", 'field-error', 'confirm','user-interaction'],
  props: ["question", "modelValue", "hideSubText",'disableConfirm', 'skipEagerValidation','forcePromptPlaceholder','hasBeenInteractedWith','disabled', 'shouldPlaceholderWrap'],
  data() {
    return {
      value: [],
      error: '',
    };
  },
  mounted() {
    const values = this.question.value ? this.question.value?.split(",") : [];
    if (values.length) {
        values.forEach(v => this.setCheckBoxValue(v))
    }

    if (
        (this.question.required &&
            !this.question.value &&
            !this.skipEagerValidation)
    ) {
      this.error = "Required";
      return this.$emit("field-error", true);
    }

    if (this.question.error) {
      this.error = this.question.error
      return this.$emit('field-error', true)
    }

  },
  methods: {
    setCheckBoxValue(v) {
      if ((this.value || []).find(el => el === v)) {
        this.value = this.value.filter(el => el !== v)
      } else if (v) {
        this.value.push(v)
      }
      if (this.question.required && !this.value.length) {
        this.error = 'Required'
        this.$emit("update:modelValue", ' ');
        return this.$emit('field-error', true)
      } else {
        this.error = ''
        this.$emit('field-error', false)
      }
      return this.$emit("update:modelValue", this.value?.join(","));
    },
  },
  watch: {
    question: {
      handler(newVal) {
        const values = newVal?.value?.split(",") ?? [];
        if (newVal?.value?.length) {
          this.$nextTick(() => {
            const newValues = values.reduce((acc, curr) => {
              if(!this.value.find(el => el === curr)){
                acc.push(curr)
              }
              return acc
            }, [])
            const valuesToRemove = this.value.reduce((acc, curr) => {
              if(!values.find(el => el === curr)){
                acc.push(curr)
              }
              return acc
            }, [])

            return [...newValues, ...valuesToRemove].forEach(v => this.setCheckBoxValue(v))
          })
          this.shouldConfirm = false;
        }

        if (newVal.error) {
          this.error = newVal.error
          return this.$emit('field-error', true)
        }
      },
      deep: true
    }
  },
  computed:{
    displayReadOnly(){
      return this.value?.length ? (
          this.value?.map(v=>this.question.options.find(el=> el.value === v)?.text)?.join(',')?.length ?
              this.value?.map(v=>this.question.options.find(el=> el.value === v)?.text)?.join(','):this.value?.join(',')
      ):'-'
    }
  }
};
</script>

<style lang="scss" scoped>
.disclaimer{
  padding: 16px !important;
  border: none !important;
  background-color: #f8f8f8;
  font-size: 10px !important;
  font-family: Roboto !important;
  line-height: 18px !important;
}
.form-check-input:focus{
  border-color: inherit;
}

.align-text-end {
  text-align: end;
}

input:checked{
  background-color: #212121;
  border-color: #212121;
}

.text-control {
  border: 1px solid #bdbdbd;
  color: #212121;
  position:relative;
  border-radius: 4px;
  width: 100%;
  padding: 16px 12px;
  font-size: 16px;
  font-weight: 400;
  font-family: "Roboto", sans-serif;
  cursor: pointer;
  min-height: 51px;

  &:disabled {
    background: #eeeeee;
    color: #949494 !important;
    border: none;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
  }

  span {
    cursor: pointer;
  }
}

.form-check-input {
  width: 20px;
  height: 20px;
  margin-top: 0.15em;
  cursor: pointer;

  &:hover:not(.disclaimer) {
    border: 2px solid #212121;
  }
}

.error {
  border-color: #bb0000;
  color: #bb0000;
}

.errorMessage {
  color: #bb0000;
}
</style>
